module.exports = __webpack_public_path__ + "img/about-img1.7a303380.png";